import template from './checkbox.html' with { type: 'html' };

export default {
	name: 'CCheckbox',
	inheritAttrs: false,
	props: {
		isChecked: {
			type: Boolean,
			default: false
		},
		checkboxLabel: {
			type: String,
			required: true
		}
	},
	template
};
